import { useEffect } from 'react';

import { useCreateCompData } from '../../hooks/api/toolkitComponents.ts';
import { useEdgeTrigger } from '../../hooks/useEdgeTrigger.ts';
import { loadNewComps } from '../../redux/features/actions/loadNewComps.ts';
import { LoadCompPayload } from '../../redux/features/actions/loadProperties.ts';
import { addCompsPosted } from '../../redux/features/orderSlice.ts';
import { selectCompsToSave } from '../../redux/features/selectors/orderSelectors.ts';
import { useAppDispatch, useAppSelector } from '../../redux/hooks.ts';

export function useCompAddSyncDriver(orderID: string) {
  const dispatch = useAppDispatch();
  const { mutate: compDataCreate } = useCreateCompData({
    onSuccess: ({ comps, sequence }) => {
      const properties = Object.entries(comps).map(([compId, comp]) => {
        return { id: compId, ...(comp as object) };
      });
      dispatch(loadNewComps({ comps: properties as LoadCompPayload[], compSequence: sequence }));
    },
  });

  const compsToSave = useAppSelector(selectCompsToSave);

  const mutationTrigger = useEdgeTrigger({
    condition: compsToSave.length > 0,
    delayMs: 0,
    action: () => {
      dispatch(addCompsPosted());
      compDataCreate({ pathParams: { orderID }, body: { comps: compsToSave } });
    },
  });

  useEffect(() => {
    mutationTrigger.restartTimer();
  }, [compsToSave, mutationTrigger]);
}
